import { ADD_METADATA, SET_METADATA, SET_PRODUCT_INFO } from "../actions/metadataActions";
import { RESET_FOR_MODEL_SELECTOR } from "../actions/sessionActions";
import MetadataState, { ModelMetadata, ProductInfoMap } from "../stateTypes/metadataState";

const initialState: MetadataState = {
    metadata: {},
    productInfo: new ProductInfoMap([]),
    productIds: {},
};

function extendProductIds(productIds: { [key: string]: number }, newMetadata: any): { [key: string]: number } {
    const newProductIds = { ...productIds };
    Object.entries(newMetadata).forEach(([dsId, entry]: [string, any]) => {
        if (entry.ProductId) {
            newProductIds[dsId] = entry.ProductId;
        }
    });
    return newProductIds;
}

function extendModelMetadata(existingMetadata: ModelMetadata | undefined, newMetadata: any): ModelMetadata {
    if (!existingMetadata) return newMetadata;
    const combinedMetadata: ModelMetadata = { ...existingMetadata };
    Object.entries(newMetadata).forEach(([dsId, entry]: [string, any]) => {
        const existingEntry = existingMetadata[dsId];
        if (existingEntry) {
            combinedMetadata[dsId] = { ...existingEntry, ...entry };
        } else {
            combinedMetadata[dsId] = entry;
        }
    });
    return combinedMetadata;
}

const metadataReducer = (state: MetadataState = initialState, action: any = {}) => {
    switch (action.type) {
        case SET_METADATA:
            return {
                ...state,
                metadata: {
                    ...state.metadata,
                    [action.modelId]: action.metadata,
                },
                productIds: extendProductIds(state.productIds, action.metadata),
            };
        case ADD_METADATA:
            return {
                ...state,
                metadata: {
                    ...state.metadata,
                    [action.modelId]: extendModelMetadata(state.metadata[action.modelId], action.metadata),
                },
                productIds: extendProductIds(state.productIds, action.metadata),
            };
        case SET_PRODUCT_INFO:
            return {
                ...state,
                productInfo: action.productInfo,
            };
        case RESET_FOR_MODEL_SELECTOR:
            return {
                ...initialState,
                // Keep same-session metadata caches so revisiting a model does not need to refetch them.
                metadata: state.metadata,
                productIds: state.productIds,
                // productInfo is session-scoped and reused when LOAD_CONFIG runs in the existing session.
                productInfo: state.productInfo,
            };
        default:
            return state;
    }
};

export default metadataReducer;
